import type { FastifyPluginAsync } from 'fastify'
import rateLimit from '@fastify/rate-limit'
import { redis, supportsRateLimitRedis } from '../../core/database/redis.js'
import { authRoutes } from './auth.routes.js'

/**
 * Auth Module
 * Registers authentication routes with stricter rate limiting
 */
export const authModule: FastifyPluginAsync = async (fastify) => {
  // ⚠️ SECURITY: Register stricter rate limiting for auth endpoints
  // Prevent brute force attacks on login/token endpoints
  await fastify.register(rateLimit, {
    max: 100, // Increased 10x: Max 100 requests per window
    timeWindow: '15 minutes', // 15 minute window
    cache: 10000,
    allowList: [], // No allowlist - apply to all origins
    redis: undefined, // DISABLED: causing 'this.redis.rateLimit is not a function' error
    skipOnError: false, // Don't skip rate limit on errors (fail secure)
  })

  // Register auth routes (parent call already mounts /api/auth prefix)
  await fastify.register(authRoutes)
}
